import { cn } from "@/lib/utils";
import { TypographyPropsModel } from "./Typography.model";

export function TypographyBase(props: TypographyPropsModel) {
  const { className, additionalClassName, as, color, size, ...componentProps } =
    props;
  const Component = as || ("div" as any);

  const classnames = `${cn(
    "align-middle whitespace-pre-line",
    additionalClassName,
    className,
    color && `text-${color}`,
    size && `font-[${size}]`,
  )}`;
  return <Component className={classnames} {...componentProps} />;
}

function Display(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Display", "text-display")}
      {...props}
    />
  );
}

function H1(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h1"
      additionalClassName={cn("Typography-H1", "text-h1")}
      {...props}
    />
  );
}

function H2(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h2"
      additionalClassName={cn("Typography-H2", "text-h2")}
      {...props}
    />
  );
}

function H3(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h3"
      additionalClassName={cn("Typography-H3", "text-h3")}
      {...props}
    />
  );
}

function H3Sentence(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h3"
      additionalClassName={cn("Typography-H3-Sentence", "text-h3-sentence")}
      {...props}
    />
  );
}

function H4(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h4"
      additionalClassName={cn("Typography-H4", "text-h4")}
      {...props}
    />
  );
}

function H5(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h5"
      additionalClassName={cn("Typography-H5", "text-h5")}
      {...props}
    />
  );
}

function H6(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="h6"
      additionalClassName={cn("Typography-H6", "text-h6")}
      {...props}
    />
  );
}

function H7(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-H7", "text-h7")}
      {...props}
    />
  );
}

function LLABEL1(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Label-Large", "text-label-lg")}
      {...props}
    />
  );
}

function LLABEL2(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn(
        "Typography-Label-Regular",
        "text-label-lg-regular",
      )}
      {...props}
    />
  );
}

function LABEL1(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="label"
      additionalClassName={cn("Typography-Label", "text-label")}
      {...props}
    />
  );
}

function LABEL2(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Label-Regular", "text-label-regular")}
      {...props}
    />
  );
}

function BODY1(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Body-Large", "text-body-lg")}
      {...props}
    />
  );
}

function BODY2(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="p"
      additionalClassName={cn("Typography-Body-Regular", "text-body-regular")}
      {...props}
    />
  );
}

function BODY3(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Body-Small", "text-body-sm")}
      {...props}
    />
  );
}

function BODY4(props: TypographyPropsModel) {
  return (
    <TypographyBase
      as="div"
      additionalClassName={cn("Typography-Body-ExtraSmall", "text-body-xs")}
      {...props}
    />
  );
}

export const Typography = {
  Display,
  H1,
  H2,
  H3,
  H3Sentence,
  H4,
  H5,
  H6,
  H7,
  LLABEL1,
  LLABEL2,
  LABEL1,
  LABEL2,
  BODY1,
  BODY2,
  BODY3,
  BODY4,
};
